/* eslint-disable react/style-prop-object */
import React, { useContext, useState } from "react";
//import Tabs from "../../Helpers/Tabs/Tabs";
import Searchbar from "../../Helpers/Searchbar/Searchbar";
import { filtrationcontext } from "../../../context/Filtercontext";
import trans from "../../../utils";
import { Tabs } from "react-bootstrap";
import { InputSelect } from "../../Helpers/Input/RefactoredInput";

export default function VehicleHead({ setFilter }) {
	const { setSearchQuery, vehicleArchived, setVehicleArchived } =
		useContext(filtrationcontext);
	const [query, setQuery] = useState("");
	const handleSearch = (e) => {
		setQuery(e.target.value);
		setSearchQuery(e.target.value);
		setVehicleArchived("All vehicles");
	};

	const handleActive = (item) => {
		if (item !== vehicleArchived) {
			setVehicleArchived(item);
		}
	};
	const typeOptions = [
		{
			label: trans("All Vehicles"),
			value: "All vehicles",
		},
		{
			label: trans("Active"),
			value: "Active",
		},
		{
			label: trans("Archived"),
			value: "Archived",
		},
	];
	const deviceTypeOptions = [
		{
			label: trans("TRACKER"),
			value: "TRACKER",
		},
		{
			label: trans("MDVR"),
			value: "MDVR",
		},
	];
	return (
		<>
			<div className="bg-white p-16 d-flex align-items-baseline gap-3">
				<Searchbar
					style="search search-dark input-group"
					path={`${process.env.PUBLIC_URL}/assets/Search.svg`}
					placeholder={trans("Search")}
					value={query}
					onChange={handleSearch}
				/>
				<InputSelect
					placeholder={trans("Type")}
					options={typeOptions}
					formstyle="flex-grow-1 text-capitalize"
					onChange={(e) => {
						handleActive(e);
					}}
				/>
				<InputSelect
					placeholder={trans("device type")}
					options={deviceTypeOptions}
					formstyle="flex-grow-1 text-capitalize"
					onChange={(e) => {
						setFilter((prev) => ({ ...prev, deviceType: e }));
					}}
				/>
			</div>
		</>
	);
}
